import React, { useCallback, useState } from 'react'
import { ISelectOption, IUnControlledSelectProps } from 'select_with_global_state/ISelect'

interface ISimpleSelectProps extends IUnControlledSelectProps {
  items: Array<ISelectOption> | null
}

const SimpleSelect: React.FC<ISimpleSelectProps> = ({
  defaultItemId,
  disabled,
  showEmpty,
  emptyOptionTitle,
  items,
  onSelect,
  style,
}) => {
  const [value, setValue] = useState<number>(defaultItemId || -1)

  const handleSelect = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      const newValue = parseInt(event.target.value)
      onSelect(newValue)
      setValue(newValue)
    },
    [onSelect]
  )

  return (
    <select
      className='form-control input-text'
      style={{ width: '100%', ...style }}
      onChange={handleSelect}
      value={value}
    >
      {items?.map((item) => (
        <option key={item.item_id} value={item.item_id}>
          {item.item_name}
        </option>
      ))}
    </select>
  )
}

export default SimpleSelect
